// extracted by mini-css-extract-plugin
export var descriptionMarkdownStyling = "descriptionStyles-module--description-markdown-styling--Zn0c6";